import { computed } from 'vue'

import { useUserLocale } from '@shared/utils/composables/locales'

import { ChatWidgetMessage } from '@protos/chat_widget_message_pb'
import { ChatWidgetMessageType } from '@protos/chat_widget_message_type_pb'
import { LocalizedEntity } from '@protos/localized_entity_pb'

import { PlainMessage } from '@bufbuild/protobuf'
import { useSessionStore } from '@pc/store/session'

export const useWidgetMessages = (messageType: ChatWidgetMessageType) => {
  const { userLocale } = useUserLocale()
  const sessionStore = useSessionStore()

  return computed(
    () =>
      sessionStore.chatProps?.chatWidget?.messages
        ?.find(
          (item: PlainMessage<ChatWidgetMessage>) =>
            item.messageType === messageType
        )
        ?.localizedTexts?.find(
          (text: PlainMessage<LocalizedEntity>) =>
            text.locale === userLocale.value
        )?.value
  )
}

export const useComplianceMessageDisplay = (
  messageType: ChatWidgetMessageType
) => {
  const sessionStore = useSessionStore()

  return computed(
    () =>
      sessionStore.chatProps?.chatWidget?.messages?.find(
        (item: PlainMessage<ChatWidgetMessage>) =>
          item.messageType === messageType
      )?.isDisplay ?? false
  )
}
